
/*eslint-disable */

/*
* gives model a opacity
*/
AFRAME.registerComponent("table-material", {
  schema: { color: { type: 'color', is: 'uniform', default: 'blue' }, },
  init: function () {
    this.el.addEventListener("model-loaded", () => {
      // console.log(this.el.object3D.children[0].children[0].children[0]);
    });


    // console.log(tex);
  },

});

AFRAME.registerComponent("texture-set", {
  schema: { color: { type: 'color', is: 'uniform', default: 'red' }, },
  init: function () {
    var tex = new Image();
    this.el.addEventListener("model-loaded", () => {
      let color = this.data.color;
      // console.log(this.el.object3D.children[0].children[0].material);
      if (color === 'Green') tex.src = "/phone/textures/iphone11pro_midnight_green.jpg";

      if (color === 'Gold') tex.src = "/phone/textures/iphone11pro_rose_gold.jpg";

      if (color === 'Silver') tex.src = "/phone/textures/iphone11pro_silver.jpg";

      if (color === 'Space Gray') tex.src = "/phone/textures/iphone11pro_silver.jpg";
      this.el.object3D.children[0].children[0].material.map.image = tex;
    });

    // console.log(tex);
  },

});
AFRAME.registerComponent("earphones-color", {
  schema: { color: { type: 'color', is: 'uniform', default: 'blue' }, },
  init: function () {
    var tex = new Image();
    this.el.addEventListener("model-loaded", () => {
      let color;
      if (this.data.color === 'red') {
        color = new THREE.Color('#e01f3d')
      }
      if (this.data.color === 'blue') {
        color = new THREE.Color('#1C9CF6')
      }
      // console.log(this.el.object3D.children[0].children[0].material);
      this.el.object3D.children[0].children[0].children[1].material.color = color
    });

    // console.log(tex);
  },

});